module.exports = __webpack_public_path__ + "img/lg_ring_y_c_null_null.4faafeaa.png";